<div class="widget-title">
    <h4>{{ 'Announcements' | transloco }}</h4>
</div>
<div class="vsc-card widget announcement-container" fxLayout="column">
    <ng-container
        *ngIf="
            (isLoading$ | async) === false && announcements$
                | async as announcements
        "
    >
        <div
            *ngFor="let announcement of announcements; let i = index"
            fxLayout="row"
            class="announcement item"
            [class.link]="!!announcement?.link"
            (click)="openPage(announcement)"
            (keydown.enter)="openPage(announcement)"
            (keydown.space)="openPage(announcement)"
            [attr.tabindex]="announcement?.link ? 0 : null"
            role="button"
            [attr.aria-label]="'Learn more about ' + announcement?.text"
        >
            <div class="date" fxLayout="column" fxLayoutAlign="start center">
                <div class="day">
                    {{ announcement.startDate | localizedDate: 'D' }}
                </div>
                <div class="month">
                    {{ announcement.startDate | localizedDate: 'MMM' }}
                </div>
            </div>
            <div
                fxFlex
                fxLayout="column"
                fxLayoutAlign="center start"
                [class.link]="!!announcement.link"
            >
                <div
                    class="announcement-name"
                    fxLayout="column"
                    fxLayoutAlign="center space-between"
                    fxLayoutGap="10px"
                >
                    <span>{{ announcement.text }}</span>
                    <div>
                        <button
                            *ngIf="announcement.link"
                            class="learn-more-btn btn-reset-style"
                            (click)="openPage(announcement)"
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            tabindex="-1"
                        >
                            <span>{{ 'Learn more' | transloco }}</span>

                            <vsc-icon iconStyle="solid" color="accent"
                                >caret-right</vsc-icon
                            >
                        </button>
                    </div>
                </div>
            </div>
            <div class="line" *ngIf="i < announcements.length - 1"></div>
        </div>
        <div *ngIf="announcements.length === 0" class="no-announcements">
            {{ 'There are no announcements' | transloco }}
        </div>
    </ng-container>
    <div class="loading" *ngIf="isLoading$ | async">
        {{ 'Loading announcements ...' | transloco }}
    </div>
</div>
